import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PaymentMethod } from '@qaroni-app/payments/types/payment-method';

@Component({
  selector: 'qaroni-payment-method-preview',
  templateUrl: './payment-method-preview.component.html',
  styleUrls: ['./payment-method-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentMethodPreviewComponent {
  readonly paymentMethod = input<PaymentMethod | null>(null);
}
